import ShareLinkContainer from './share-link.container';

export default ShareLinkContainer;
